var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c(
      "div",
      { staticClass: "modal-header" },
      [
        _c(
          "md-button",
          {
            staticClass: "md-simple md-just-icon md-round modal-default-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_c("md-icon", [_vm._v("clear")])],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _c(
          "simple-wizard",
          {
            attrs: {
              plain: "",
              "show-header": false,
              title: _vm.title + _vm.mainTitle,
              "sub-title": "",
              "finish-button-text": _vm.title,
              "next-button-text": "next",
            },
            on: { finish: _vm.validateDetails, stepChange: _vm.stepChange },
          },
          [
            _c(
              "wizard-tab",
              {
                attrs: {
                  "before-change": _vm.validateDetails,
                  id: "adjustment",
                },
              },
              [
                _c("template", { slot: "label" }, [
                  _vm._v("\n                    Details\n                "),
                ]),
                _c(
                  "form-wrapper",
                  {
                    staticClass: "form-wrapper",
                    attrs: { validator: _vm.$v.adjustment },
                  },
                  [
                    _vm.title.toLowerCase().trim() === "create"
                      ? _c("adjustment-step", {
                          attrs: {
                            "adjustment-details": _vm.adjustment,
                            "show-customer": _vm.isCustomer,
                            "show-driver": _vm.isDriver,
                          },
                          on: {
                            isDriver: _vm.setDriver,
                            isCustomer: _vm.setCustomer,
                          },
                        })
                      : _vm._e(),
                    _c("adjustment-details-step", {
                      attrs: {
                        "adjustment-details": _vm.adjustment,
                        categories: _vm.invoiceAdjustmentCategories,
                        "team-members": _vm.teamMembers,
                        customers: _vm.customerList,
                      },
                    }),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
        _vm._m(0),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("b", [_vm._v("Important:")]),
      _vm._v(
        " When this adjustment is approved, it will automatically be added to any draft invoices that already exist for the same date range.\n        "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }